import docsAction from './docsAction';

export default {
  namespaced: true,
  state() {},
  getters: {},
  mutations: {},
  actions: docsAction,
};
